// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusSquareOutlinedSvg from "@fishx/icons-svg/es/asn/MinusSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareOutlinedSvg
  }));
};

MinusSquareOutlined.displayName = 'MinusSquareOutlined';
export default React.forwardRef(MinusSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MinusSquareOutlined.js
// module id = 3141
// module chunks = 0